<template>
  <section class="hero header-image is-dark is-fullheight">
    <!-- Hero head: will stick at the top -->
    <div class="hero nav-bar is-fullheight">
    <div class="hero-head">
      <nav class="navbar" >
        <div class="navbar-brand navbar-brand-space-between">
          <a class="navbar-item nav fix">
            <Logo white/>
            <!--<img src="../assets/logo.png" alt="Logo">-->
          </a>
        </div>
      </nav>
    </div>
    <!-- Hero content: will be in the middle -->
    <div class="hero-body hero-body-small-padding" >
      <div class="container has-text-centered">
        <h1 class="title is-1 is-spaced">
          {{content.title}}
        </h1>
        <a class="button is-danger is-large"  href="#" v-scroll-to="'#schedule'" >
            <span>{{content.cta}}</span>     
        </a>
      </div>
    </div>

    <!-- Hero footer: will stick at the bottom -->
    <div class="hero-foot nav-bar">
      <nav class="tabs">
        <div class="container">
          <ul>
            <li>
              <a href="#" v-scroll-to="'#schedule'">Schedule</a>
            </li>
            <li>
              <a href="#" v-scroll-to="'#location'">Location</a>
            </li>
            <li>
              <a href="#" v-scroll-to="'#faq'" >FAQs</a>
            </li>
          </ul>
        </div>
      </nav>
    </div>
        </div>

  </section>
</template>

<script>
  import Logo from './Logo.vue'
  export default {
    name: 'NavBar',
    components:{
      Logo,
    },
    props: ['content']
  }
</script>

<style scoped>
 .fix {
    background-color: rgba(0,0,0,0) !important;

 }
 .fix:hover {

 }
  .header-image {
    background-image: url("https://cdn3.joinfightcamp.com/2000x0/v4/fc-experience-coach-pj-studio-001.jpg");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    background-color: #999;
  }
  .nav-bar {
    background-color: rgba(0,0,0,0.2) !important;
  }
  
  .hero-body-small-padding {

  }
  .remove-purple {
    background-color: rgba(0,0,0,0.2) !important;
  }
  
  
</style>